import { Controller } from "stimulus"
import axios from 'axios'
import { isBlank } from '../../commons.js'

export default class extends Controller {

  static targets = [
    "clientSelect", "cfileSelect", "reminderDaysSelect", "destroyFlag", "deadlineDateLabel"
  ]

  // Sélection d'un client différent, maj de la liste des dossiers (requête JSON)
  client_change(e) {
    const client_id = this.clientSelectTarget.value
    this.cfileSelectTarget.innerHTML = '';
    this.cfileSelectTarget.add(new Option('', ''));
    if (this.clientSelectTarget.value) {
      axios.get(`/cfiles/for_client.json?client_id=${client_id}`)
        .then(response => {
          for (const d of response.data) {
            let option = new Option(d.name, d.id);
            option.dataset.hourlyrate = d.hourlyrate;
            option.dataset.language = d.language;
            this.cfileSelectTarget.add(option);
          }
        })
    }
  }

  reminder_change(e) {
    const no_reminder = isBlank(this.reminderDaysSelectTarget.value)
    this.destroyFlagTarget.setAttribute("value", no_reminder ? "true" : "false") // nested_fields reminders
    if (no_reminder)
      this.deadlineDateLabelTarget.classList.remove("required")
    else
      this.deadlineDateLabelTarget.classList.add("required")
  }

}